
<component
	:is="element"
	ref="flow-text"
	class="flow-text"
	:class="classes"
	:data-family="family"
	:data-weight="weight"
	:data-color="color"
	:data-transform="transform"
	:data-overflow="overflow"
	:data-link="link"
	:data-inline="inline"
	:style="styleObj"
>
	<slot />
</component>
